export default __webpack_public_path__ + "static/media/453.562e5bc8.gif";